// src/v3/account/comments.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var CommentsIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "CommentsIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M11.994 2.25a9.75 9.75 0 0 1 8.608 14.332l1.064 3.193a1.5 1.5 0 0 1-1.898 1.897l-3.192-1.064A9.75 9.75 0 1 1 11.994 2.25Zm0 18a8.237 8.237 0 0 0 4.13-1.107.75.75 0 0 1 .614-.063l3.506 1.17-1.17-3.506a.752.752 0 0 1 .063-.613 8.25 8.25 0 1 0-7.143 4.119Z"
  }
) });

export {
  CommentsIcon
};
